<template>
  <zj-layout-container>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" :disabled="editable" style="height:100%;">
      <el-tabs class="user-tabs" v-model="editableTabsValue" height="100%">
        <el-tab-pane
          :key="item.name"
          v-for="(item) in editableTabs"
          :label="item.Extend1"
          :name="item.ItemKey"
        >
          <UserOrgControl
            @loading="showLoading"
            @loadingFinish="hideLoading"
            :existingReceivers="existingReceivers"
            :ResourceTypeId="item.ItemKey"
            :ref="item.ItemKey"></UserOrgControl>
        </el-tab-pane>
      </el-tabs>
    </el-form>
  </zj-layout-container>
</template>
<script>
//import MyApis from "../../../apis";
import UserOrgControl from "./UserOrgControl";
export default {
  name: "ZjUserTabControl",
  controller: "UI",
  action: "UserTabControl",
  components: {
    UserOrgControl
  },
  props: {
    editable: { type: Boolean, default: false },
    existingReceivers:Object
  },
  data() {
    return {
      ruleForm: {},
      editableTabs: [],
      editableTabsValue: "",
      orgOptions: [],
      OgrVal: ""
    };
  },
  created: function() {
    this.showLoading('加载中...');
    this.config
      .getUValue("EmergencyService:PersonOrgianiztionType:", "")
      .then(d => {
        if (d.JValue && d.JValue.length > 0) {
          this.editableTabs = d.JValue;
          this.editableTabsValue = d.JValue[0].ItemKey;
        }
        this.hideLoading();
      })
      .catch(e => {
        console.error(e);
        this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        this.hideLoading();
      });
  },
  methods: {
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox"
      });
    },
    showLoading(text) {
      this.$emit('loading', text);
    },
    hideLoading() {
      this.$emit('loadingFinish');
    },
    GetOrgUserIds() {
      var userids = [];
      for (var i = 0; i < this.editableTabs.length; i++) {
        var item = this.editableTabs[i];
        var chil = this.$refs[item.ItemKey][0];
        var usids = chil.GetUserIds();
        for (var j = 0; j < usids.length; j++) {
          userids.push(usids[j]);
        }
      }
      return userids;
    },
    GetCheckedUserItems() {
      var reuslt = [];
      for (var i = 0; i < this.editableTabs.length; i++) {
        var item = this.editableTabs[i];
        var chil = this.$refs[item.ItemKey][0];
        var checkItems = chil.GetCheckedUserItems();
        reuslt = reuslt.concat(checkItems);
      }
      return reuslt;
    }
  }
};
</script>
